import { getIcon } from '../utils/helpers';

import { MODULE_1_UNITS } from './modules/m1';
import { MODULE_2_UNITS } from './modules/m2';
import { MODULE_3_UNITS } from './modules/m3';
import { MODULE_4_UNITS } from './modules/m4';
import { MODULE_5_UNITS } from './modules/m5';
import { MODULE_6_UNITS } from './modules/m6';
import { MODULE_7_UNITS } from './modules/m7';
import { MODULE_8_UNITS } from './modules/m8';
import { MODULE_9_UNITS } from './modules/m9';
import { MODULE_10_UNITS } from './modules/m10';

import { GRAMMAR_M1 } from './grammar/m1';
import { GRAMMAR_M2 } from './grammar/m2';
import { GRAMMAR_M3 } from './grammar/m3';
import { GRAMMAR_M4 } from './grammar/m4';
import { GRAMMAR_M5 } from './grammar/m5';
import { GRAMMAR_M6 } from './grammar/m6';
import { GRAMMAR_M7 } from './grammar/m7';
import { GRAMMAR_M8 } from './grammar/m8';
import { GRAMMAR_M9 } from './grammar/m9';
import { GRAMMAR_M10 } from './grammar/m10';

const processUnits = (units) => {
  return (units || [])
    .filter(unit => unit && typeof unit === 'object') // 1. Filtra elementos nulos o corruptos
    .map(unit => ({
      ...unit,
      // 2. Usa '?' para evitar errores y define un icono por defecto
      icon: getIcon(unit?.iconType || 'default') 
    }));
};
export const ACADEMY_DATA = {
  m1: {
    id: "m1",
    name: "Módulo 1: Foundations",
    description: "Bases del inglés: Identidad, Familia y Rutinas.",
    grammarImage: "grammar/m1-grammar.jpg", 
    grammarTopics: GRAMMAR_M1,
    units: processUnits(MODULE_1_UNITS)
  },
  m2: {
    id: "m2",
    name: "Módulo 2: Around Town & Daily Life",
    description: "Learn to ask questions and describe your town.",
    grammarImage: "/m2-grammar-overview.jpg", 
    grammarTopics: GRAMMAR_M2,
    units: processUnits(MODULE_2_UNITS)
  },
  m3: {
    id: "m3",
    name: "Módulo 3: Clothes & Shopping",
    description: "Domina el vocabulario de compras y precios.",
    grammarImage: "/m3-intro.jpg", 
    grammarTopics: GRAMMAR_M3,
    units: processUnits(MODULE_3_UNITS)
  },
   m4: {
    id: "m4",
    name: "Módulo 4: Personal information",
    description: "Domina el vocabulario de compras y precios.",
    grammarImage: "/m4-intro.jpg", 
    grammarTopics: GRAMMAR_M4,
    units: processUnits(MODULE_4_UNITS)
  },
   m5: {
    id: "m5",
    name: "Módulo 5: Past Simple",
    description: "Domina el vocabulario de pasado y futuro.",
    grammarImage: "/m5-intro.jpg", 
    grammarTopics: GRAMMAR_M5,
    units: processUnits(MODULE_5_UNITS)
  },
   m6: {
    id: "m6",
    name: "Módulo 6: plans",
    description: "Domina el vocabulario del futuro.",
    grammarImage: "/m6-intro.jpg", 
    grammarTopics: GRAMMAR_M6,
    units: processUnits(MODULE_6_UNITS)
  },
   m7: {
    id: "m7",
    name: "Módulo 7: b1",
    description: "Domina el vocabulario.",
    grammarImage: "/m7-intro.jpg", 
    grammarTopics: GRAMMAR_M7,
    units: processUnits(MODULE_7_UNITS)
  },
  m8: {
    id: "m8",
    name: "Módulo 8: Present Perfect",
    description: "Domina el vocabulario del presente perfecto.",
    grammarImage: "/m8-intro.jpg", 
    grammarTopics: GRAMMAR_M8,
    units: processUnits(MODULE_8_UNITS)
  },
  m9: {
    id: "m9",
    name: "Módulo 9: Health Vocabulary",
    description: "Domina el vocabulario de salud.",
    grammarImage: "/m9-intro.jpg", 
    grammarTopics: GRAMMAR_M9,
    units: processUnits(MODULE_9_UNITS)
  },
  m10: {
    id: "m10",
    name: "Módulo 10: Business Vocabulary",
    description: "Domina el vocabulario de negocios.",
    grammarImage: "/m10-intro.jpg", 
    grammarTopics: GRAMMAR_M10,
    units: processUnits(MODULE_10_UNITS)
  }
};